
import { defineComponent, ref, Ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import store from '@/store';

import Navbar from '@/components/Navbar.vue';
import Post from '@/components/Post.vue';
import SubredditSidebar from '@/components/SubredditSidebar.vue';
import InfoSidebar from '@/components/InfoSidebar.vue';
import Comment from '@/components/Comment.vue';

export default defineComponent({
	components: {
		Navbar,
		Post,
		SubredditSidebar,
		Comment,
		InfoSidebar,
	},
	setup() {
		const route = useRoute();
		const router = useRouter();

		const newCommentTextarea: Ref<HTMLTextAreaElement | null> = ref(null);
		store.post.actions
			.getPost(route.params.id.toString(), true, true)
			.then(
				() =>
					(document.title = `${store.post.state.currentPost?.title} | (not) reddit`)
			);

		const commentInput = ref('');
		const mdPreview = ref(false);

		onMounted(() => {
			window.scrollTo(0, 0);
		});

		watch(commentInput, () => {
			if (!newCommentTextarea.value) return;
			newCommentTextarea.value.style.height = 'auto';
			newCommentTextarea.value.style.height = `${newCommentTextarea.value.scrollHeight}px`;
		});

		// minimise this
		function textAreaHandler(e: KeyboardEvent) {
			if (!newCommentTextarea.value) return;
			let contentArr = [...newCommentTextarea.value.value];

			const delimiters: any = {
				//let's me use [] without writing a type
				always: {
					'"': '"',
					'(': ')',
					'{': '}',
					'[': ']',
					'<': '>',
					'`': '`',
				},
				nextToWhitespace: {
					"'": "'",
					_: '_',
					'*': '*',
					'~': '~',
				},
			};

			const ctrlChars: any = {
				b: '**',
				i: '_',
			};

			const cursorStart = newCommentTextarea.value.selectionStart;
			const cursorEnd = newCommentTextarea.value.selectionEnd;

			// handle selection delimiters
			if (cursorStart !== cursorEnd) {
				if (e.key === 'Backspace') return;

				if (e.ctrlKey && e.key in ctrlChars) {
					e.preventDefault();
					contentArr.splice(cursorStart, 0, ctrlChars[e.key]);
					contentArr.splice(cursorEnd + 1, 0, ctrlChars[e.key]);
					newCommentTextarea.value.value = contentArr.join('');
					newCommentTextarea.value.selectionStart = cursorStart;
					newCommentTextarea.value.selectionEnd =
						cursorEnd + ctrlChars[e.key].length * 2;
					return;
				}

				if (
					!(
						e.key in delimiters.always ||
						e.key in delimiters.nextToWhitespace
					)
				)
					return;
				e.preventDefault();
				const delimiter1 =
					delimiters.always[e.key] ||
					delimiters.nextToWhitespace[e.key];

				contentArr.splice(cursorStart, 0, e.key);
				contentArr.splice(cursorEnd + 1, 0, delimiter1);
				newCommentTextarea.value.value = contentArr.join('');

				newCommentTextarea.value.selectionStart = cursorStart;
				newCommentTextarea.value.selectionEnd = cursorEnd + 2;

				return;
			}

			// handle regular delimiters
			if (e.key === 'Backspace') {
				if (
					!(
						(contentArr[cursorStart] in delimiters.always ||
							contentArr[cursorStart] in
								delimiters.nextToWhitespace) &&
						(contentArr[cursorStart - 1] in delimiters.always ||
							contentArr[cursorStart - 1] in
								delimiters.nextToWhitespace)
					)
				)
					return;
				contentArr.splice(cursorStart, 1);
			} else if (e.ctrlKey && e.key in ctrlChars) {
				e.preventDefault();
				contentArr.splice(
					cursorStart,
					0,
					ctrlChars[e.key] + ctrlChars[e.key]
				);
				newCommentTextarea.value.value = contentArr.join('');
				newCommentTextarea.value.selectionStart =
					cursorStart + ctrlChars[e.key].length;
				newCommentTextarea.value.selectionEnd =
					cursorStart + ctrlChars[e.key].length;
				return;
			} else if (e.key in delimiters.always) {
				contentArr.splice(cursorStart, 0, delimiters.always[e.key]);
			} else if (e.key in delimiters.nextToWhitespace) {
				if (/^\S$/g.test(contentArr[cursorStart - 1])) return;
				contentArr.splice(
					cursorStart,
					0,
					delimiters.nextToWhitespace[e.key]
				);
			} else return;

			newCommentTextarea.value.value = contentArr.join('');
			newCommentTextarea.value.selectionEnd = cursorStart;
			newCommentTextarea.value.selectionStart = cursorStart;
		}

		async function createComment() {
			if (!commentInput.value.replace(/\s+/g, '').length)
				return alert('Your comment must not be empty.');

			const button = document.getElementById(
				'submitCommentButton'
			) as HTMLButtonElement;

			button.disabled = true;

			await store.post.actions.createComment({
				content: commentInput.value,
				post_id: store.post.state.currentPost.id || '',
				parent_id: null,
				subreddit_id: store.post.state.currentPost.subreddit_id || '',
				user_id: store.auth.state.user?.id || '',
			});

			button.disabled = false;
			commentInput.value = '';
		}

		function backButton() {
			if (window.history.state.back) router.go(-1);
			else
				router.push({
					path: `/r/${route.params.subreddit.toString()}`,
				});
		}

		return {
			route,
			router,
			store,
			textAreaHandler,
			commentInput,
			newCommentTextarea,
			mdPreview,
			backButton,
			createComment,
		};
	},
});
